// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LoginPage, RegisterPage } from './pages/Login';
import Dashboard from './pages/Dashboard';
import Admins from './pages/Admins';
import Users from './pages/Users';
import Staff from './pages/Staff';
import Trains from './pages/Trains';
import Layout from './components/Layout';
import './index.css';
import AllTrains from './pages/AllTrains';
import trainsData from '../src/assets/trains.json';
import TrainRoute from './pages/TrainRoute';

function Protected({ children }) {
  const { admin, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1a1a1a' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 32, marginBottom: 12 }}>🚂</div>
        <div style={{ color: '#a7aaad', fontSize: 13 }}>লোড হচ্ছে...</div>
      </div>
    </div>
  );
  if (!admin) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function Public({ children }) {
  const { admin, loading } = useAuth();
  if (loading) return null;
  if (admin) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Public><LoginPage /></Public>} />
          <Route path="/register" element={<Public><RegisterPage /></Public>} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/admins" element={<Protected><Admins /></Protected>} />
          <Route path="/users" element={<Protected><Users /></Protected>} />
          <Route path="/staff" element={<Protected><Staff /></Protected>} />
          <Route path="/live-trains" element={<Protected><Trains /></Protected>} />
          <Route path="/trains/:id" element={<Protected><TrainRoute /></Protected>} />
          <Route path="/all-trains" element={<Protected><AllTrains trainsData={trainsData.data} /></Protected>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
